'use client';
import { FC } from 'react';

import Head from 'next/head';
import { usePathname } from 'next/navigation';

interface MetaInfoProps {
  title?: string;
  description?: string;
  canonical?: string;
  showChatbot?: boolean;
  visitedLinks?: string[];
}
const MetaInfo: FC<MetaInfoProps> = ({
  title,
  description,
  canonical,
  visitedLinks = [],
}) => {
  const pathname = usePathname();

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name='referrer' content='origin' />
        <meta name='description' content={description} />
        <meta name='viewport' content='initial-scale=1.0, width=device-width' />
        {/\?/.test(pathname ?? '') ? (
          <meta name='robots' content='noindex' />
        ) : null}
        {!visitedLinks.length && canonical ? (
          <link rel='canonical' href={canonical} />
        ) : null}
        {visitedLinks.map((visitedLink) => (
          <link key={visitedLink} href={visitedLink} />
        ))}
      </Head>
    </>
  );
};

export default MetaInfo;
